import { Tabs } from "antd";
import "./filters.css";
import backIcon from "../../../assets/images/arrow-left.svg";
import feedIcon from "../../../assets/images/feed.svg";
import newsIcon from "../../../assets/images/news.svg";
import trendingIcon from "../../../assets/images/trending-gray.svg";
import bookmarkIcon from "../../../assets/images/bookmark-colored.svg";
import filterIcon from "../../../assets/images/filter.svg";
import feedIconPurple from "../../../assets/images/feed-purple.svg";
import trendingIconPurple from "../../../assets/images/trending-purple.svg";
import newsIconPurple from "../../../assets/images/news-purple.svg";
import bookmarkIconGray from "../../../assets/images/bookmark-gray.svg";
import { useNavigate } from "react-router-dom";
import { trackZymedEvent, ZYMED_EVENTS } from "../../../utils/zymedAnalytics";

const FilterTabs = ({ activeTab, setActiveTab }: any) => {
  const items = [
    {
      key: "myFeed",
      label: (
        <div
          className={`flex items-center justify-center gap-1 px-6 py-2 border rounded-full text-[14px] font-semibold leading-[22px] ${
            activeTab === "myFeed"
              ? "border border-[#4B4AD5] bg-[#6C6CDE1F] text-[#4B4AD5]"
              : "text-gray-600 font-medium"
          }`}
        >
          <img
            src={activeTab === "myFeed" ? feedIconPurple : feedIcon}
            alt="feed-icon"
            className="w-4 h-4"
          />
          <span>My feed</span>
        </div>
      ),
    },
    {
      key: "trending",
      label: (
        <div
          className={`flex items-center justify-center gap-1 px-6 py-2 border rounded-full text-[14px] font-semibold leading-[22px] ${
            activeTab === "trending"
              ? "border border-[#4B4AD5] bg-[#6C6CDE1F] text-[#4B4AD5]"
              : "text-gray-600 font-medium"
          }`}
        >
          <img
            src={activeTab === "trending" ? trendingIconPurple : trendingIcon}
            alt="trending-icon"
            className="w-4 h-4"
          />
          <span>Trending</span>
        </div>
      ),
    },
    {
      key: "allNews",
      label: (
        <div
          className={`flex items-center justify-center gap-1 px-6 py-2 border rounded-full text-[14px] font-semibold leading-[22px] ${
            activeTab === "allNews"
              ? "border border-[#4B4AD5] bg-[#6C6CDE1F] text-[#4B4AD5]"
              : "text-gray-600 font-medium"
          }`}
        >
          <img
            src={activeTab === "allNews" ? newsIconPurple : newsIcon}
            alt="filter-icon"
            className="w-4 h-4"
          />
          <span>All News</span>
        </div>
      ),
    },
    {
      key: "bookmarks",
      label: (
        <div
          className={`flex items-center justify-center gap-1 px-6 py-2 border rounded-full text-[14px] font-semibold leading-[22px] ${
            activeTab === "bookmarks"
              ? "border border-[#4B4AD5] bg-[#6C6CDE1F] text-[#4B4AD5]"
              : "text-gray-600"
          }`}
        >
          <img
            src={activeTab === "bookmarks" ? bookmarkIcon : bookmarkIconGray}
            alt="filter-icon"
            className="w-4 h-4"
          />
          <span>Bookmarks</span>
        </div>
      ),
    },
  ];
  const navigate = useNavigate();

  /** Pill labels as the taxonomy names them. */
  const TAB_NAME: Record<string, string> = {
    myFeed: "My Feed",
    trending: "Trending",
    allNews: "All News",
    bookmarks: "Bookmarks",
  };

  const onTabClick = (key: string) => {
    if (key !== activeTab) {
      trackZymedEvent(ZYMED_EVENTS.SHOTS_FEED_TAB_SWITCHED, {
        tab_name: TAB_NAME[key] ?? key,
      });
    }
    setActiveTab(key);
  };

  return (
    <div className="flex justify-center items-center bg-white z-20 absolute top-0 w-full max-w-screen-md">
      <img
        height={22}
        width={22}
        src={backIcon}
        alt="arrow-left"
        onClick={() => navigate("/tatva-shots-home")}
        className="mx-3"
      />
      <Tabs
        defaultActiveKey="myFeed"
        tabBarGutter={16}
        className="flex-1 flex-shrink-0 w-[120px] overflow-x-auto custom-tabs my-1 shadow-none"
        items={items}
        moreIcon={null} // To remove the default dropdown icon
        activeKey={activeTab}
        onChange={onTabClick}
        tabBarStyle={{ margin: 0 }}
      />
      {activeTab === "myFeed" && (
        <img
          src={filterIcon}
          alt="filter"
          onClick={() => {
            trackZymedEvent(ZYMED_EVENTS.SHOTS_FILTER_SORT_CLICKED);
            navigate("/preferences", { state: { returnTab: activeTab } });
          }}
        />
      )}
    </div>
  );
};

export default FilterTabs;
